import { collection, onSnapshot, query } from "firebase/firestore";
import { db } from "../../../services/firebase";
import useSWRSubscription from "swr/subscription";
import { FIRESTORE_ORDER_LIMITS_TABLE } from "../../../constants/FirebaseConstants";

export function useOrderLimits() {
  const { data } = useSWRSubscription("orderLimits", (key, { next }) => {
    const q = query(collection(db, FIRESTORE_ORDER_LIMITS_TABLE));
    return onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
      next(null, data);
    });
  });

  return {
    data,
    loading: !data,
  };
}
